exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/app/extend-booking-payment-success/extend-booking-payment-success.component.scss
// module id = ../../../../../src/app/extend-booking-payment-success/extend-booking-payment-success.component.scss
// module chunks = main